import React, { SVGProps } from 'react';
const chevronLeftOutlined = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="m19.06 24 1.88-1.88L14.833 16l6.107-6.12L19.06 8l-8 8z" /></svg>;
export default chevronLeftOutlined;